import React, { useEffect, useRef, useState } from "react";
import MeasureSvgWave from "./SvgWave";
import HeartRateDraw from "./HeartRateDraw";

function Index({
    isDraggable = true,
    data,
    width,
    height,
    isHrValueChecked    
}) {
    const areaRef = useRef(null);
    const [time, setTime] = useState(0);
    const [dragging, setDragging] = useState(false);
    const [startPosition, setStartPosition] = useState(null);
    const [currentPosition, setCurrentPosition] = useState(null);
    const [endPosition, setEndPosition] = useState(null);

    //마우스 클릭 시작 이벤트
    const handleMouseDown = (e) => {
        if (!isDraggable) return;
        setStartPosition(null);
        setEndPosition(null);

        const bounds = areaRef.current.getBoundingClientRect();
        setDragging(true);
        const mouseX = e.clientX - bounds.left;
        const mouseY = e.clientY - bounds.top; // y 좌표 보정
        setStartPosition({ x: mouseX, y: mouseY });
        setCurrentPosition({ x: mouseX, y: mouseY });        
        //handleSelectBox();
        setTime(0); //기존 값 남아 있는 경우가 있어서 수정.
    };

    //마우스 움직임 이벤트
    const handleMouseMove = (e) => {
        if (!dragging) return;

        const bounds = areaRef.current.getBoundingClientRect();
        const mouseX = e.clientX - bounds.left;
        const clampedX = Math.min(Math.max(mouseX, 0), bounds.width);
        const mouseY = e.clientY - bounds.top; // y 좌표 보정

        setCurrentPosition({ x: clampedX, y: mouseY });
        setEndPosition({ x: clampedX, y: mouseY })

        const startTime = (startPosition.x / bounds.width) * 10;
        const currentTime = (clampedX / bounds.width) * 10;
        const elapsedTime = Math.abs(currentTime - startTime).toFixed(2);
        setTime(elapsedTime);
    };

    //마우스 클릭 해제 이벤트
    const handleMouseUp = () => {
        if (!dragging) return;

        setDragging(false);        
        //setStartPosition(null);
        //setCurrentPosition(null);
    };

    useEffect(() => {   
        setStartPosition(null);
        setEndPosition(null);
    }, [isDraggable])
    

    return (
        <div
            ref={areaRef}
            className="relative w-full overflow-hidden"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
        >
            {/* svg background로 사용 */}
            {isHrValueChecked ? (                
                <HeartRateDraw
                    data={data}
                    width={width}
                    height={height}
                    style={'border-[1px] border-[#2F2F2F] border-box hover:border-dotted hover:border-[1px] hover:border-[#fff] active:border-dotted active:border-[1px] active:border-[#fff]'}
                    className="absolute inset-0"            
                />
            ) : (
                <MeasureSvgWave                    
                    data={data}
                    width={width}
                    height={height}
                    style={'border-[1px] border-[#2F2F2F] border-box hover:border-dotted hover:border-[1px] hover:border-[#fff] active:border-dotted active:border-[1px] active:border-[#fff]'}
                    className="absolute inset-0"
                />
            )}

            {/* 드래그 시 시간 표기  */}
            {currentPosition && startPosition && (
                <div
                    className="absolute px-2 py-1 font-bold text-white rounded bg-opacity-80"
                    style={{                        
                        top: currentPosition.y <= (height / 2) ? (startPosition.y + currentPosition.y) / 2 + 10 : (startPosition.y + currentPosition.y) / 2 - 20,
                        left: (startPosition.x + currentPosition.x) / 2,
                        transform: `translate(-25%, -25%)`,                        
                    }}
                >
                    {time}s
                </div>
            )}
            {/* 드래그 첫 시작 원 그리기 */}
            {startPosition && (
                <div
                    className="absolute w-2.5 h-2.5 rounded-full border-2 border-white"
                    style={{
                        top: startPosition.y - 4,
                        left: startPosition.x - 4,
                    }}
                />
            )}

            {/* 마우스 원 + 시작점 끝점 선 그리기 */}
            {endPosition && (
                <>
                    <div
                        className="absolute w-2.5 h-2.5 rounded-full border-2 border-white"
                        style={{
                            top: endPosition.y - 4,
                            left: endPosition.x - 4,
                        }}
                    />
                    <div
                        className="absolute h-0 origin-top-left border-t-[1px] border-white border-dashed"
                        style={{
                            top: startPosition.y,
                            left: startPosition.x,
                            width: Math.sqrt(
                                (endPosition.x - startPosition.x) ** 2 +
                                    (endPosition.y - startPosition.y) ** 2
                            ),
                            transform: `rotate(${Math.atan2(
                                endPosition.y - startPosition.y,
                                endPosition.x - startPosition.x
                            )}rad)`,
                        }}
                    />
                </>
            )}
        </div>
    );
}

export default Index;
